import React from 'react'
import FormComponent from '../../components/formComponent';
import AlertComponent from '../../components/alertComponent';
import { Redirect } from 'react-router-dom';
import { ElementList } from '../../components/elementList';
import StepManager from '../../components/stepManager';

const DEFAULT_JOIN_EUI = '0000000000000000';

const documentation = {
    title: "New LoRaWAN device",
    subtitle: "Creates a new LoRaWAN Acuadori Device",
    brief: 'Sets the device OTA Application and GenApp key.',
    content: <p>Insert the OTA keys for the device:
             <li>32 HEX digit per Application Key</li> <li>32 HEX digit per Gen Application Key</li>
    </p>,
    steps: [
        {
            id: 0,
            title: 'Add LoraWAN Device',
            brief: 'Creates a Chirpstack device, linked to thingsboard, identified by its EUI.',
            content: <p><li>Select the Thingsboard Device to be linked to.</li>
                <li>Choose the LoraWAN Application and Device Profile.</li>
                <li>Enter the Device EUI (as 16 HEX char).</li>
                <li>Optionally enter the Join EUI (EUI64); when empty it defaults to 0000000000000000.</li>
            </p>

        },
        {
            id: 1,
            title: 'Set Device Keys',
            brief: 'Sets the device OTA Application and GenApp key.',
            content: <p>Insert the OTA keys for the device:
                <ul>
                    <li>32 HEX digit per Application Key</li>
                    <li>32 HEX digit per Gen Application Key</li>
                </ul>
            </p>

        },

    ]
}


class ChsUiDevice extends React.Component {

    static defaultProps = {
        title: 'New LoRaWAN device'
    };
    constructor(props) {
        super(props);

        this.deviceService = props.services.device;
        this.thingsboardDeviceService = props.services.thingsboardDevice;

        this.stepManagerRef = React.createRef();

        this.state = {
            finished: false,
            alert: {
                messageAlert: 'message',
                variantAlert: 'primary',
                showAlert: false,
            },

            thingsboardDevices: null,
            applicationList: null,
            deviceProfileList: null,
            organizationList: null,
        }
        this.deviceStorage = {};
        this.deviceKeyStorage = {};

    }

    componentDidMount() {
        this.handleApplicationList().then(
            () => {
                //this.renderAlert('Application Ready', 'success');
            }).catch(this.handleSubmitError);
    }

    documentation = (title) => {
        if (!title) { return documentation; }

        let doc = documentation;
        documentation.title = title;
        return doc;
    }


    renderAlert = (message, variant) => {
        this.setState({ alert: { messageAlert: message, variantAlert: variant, showAlert: true } });
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };


    getApplicationList = (values) => {
        return this.deviceService.getApplications(values).then(
            (response) => {
                let apps = this.deviceService.storage.getItem(response.storageTag, response.storageItem);
                this.setState({ applicationList: apps });

            }
        ).catch(this.handleSubmitError)
    }

    getDeviceProfileList = (values) => {
        return this.deviceService.getDeviceProfiles(values).then(
            (response) => {
                let devProfiles = this.deviceService.storage.getItem(response.storageTag, response.storageItem);
                this.setState({ deviceProfileList: devProfiles });
            }
        ).catch(this.handleSubmitError);
    }

    getThingsboardDeviceList = (values) => {
        return this.thingsboardDeviceService.getDevices().then((result) => {
            this.setState({ thingsboardDevices: result.data });
        })
    }

    handleApplicationList = (values = {}) => {
        const query = { ...values, limit: 100 };
        const tenantId = (process.env.REACT_APP_CHIRPSTACK_TENANT_ID || '').trim();

        if (!tenantId) {
            return Promise.reject(Error('ChirpStack tenant ID required'));
        }

        const tenantQuery = {
            ...query,
            tenantId: tenantId
        };

        return this.getThingsboardDeviceList(query)
            .then(() => Promise.all([
                this.getDeviceProfileList(tenantQuery),
                this.getApplicationList(tenantQuery)
            ]));
    };

    searchArray = (name, array, defaultId) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i]) {
                if (array[i].name) {
                    if (array[i].name === name) {
                        return array[i];
                    }
                }
            }
        }
        if (Number.isInteger(defaultId)) {
            return array[defaultId];
        }
        return {};
    }

    handleDeviceAdd = (values) => {

        let { thingsboardDevices, applicationList, deviceProfileList } = this.state;

        let thbDevice = this.searchArray(values.thbDevice, thingsboardDevices, 0);
        let application = this.searchArray(values.applicationID, applicationList, 0);
        let deviceProfile = this.searchArray(values.deviceProfileID, deviceProfileList, 0);

        return this.thingsboardDeviceService.getCredentials(thbDevice.id.id).then((thbToken) => {

            let devicedata = {};

            devicedata.name = thbDevice.name
            devicedata.applicationId = '' + application.id;
            devicedata.deviceProfileId = '' + deviceProfile.id;
            devicedata.devEui = values.devEUI.trim().toUpperCase();
            devicedata.joinEui = (values.joinEUI || DEFAULT_JOIN_EUI).trim().toUpperCase() || DEFAULT_JOIN_EUI;
            devicedata.variables = { "ThingsBoardAccessToken": thbToken };

            devicedata.description = "Api Device " + devicedata.name;
            devicedata.skipFCntCheck = false;
            devicedata.tags = {};


            console.log(devicedata);

            return this.deviceService.addDevice(devicedata).then(
                (response) => {
                    console.log(response)

                    this.deviceStorage = response; //{storageTag: 'chirpstack/', storageItem: 'device'};
                    this.stepManagerAdvance();
                    this.renderAlert('Device Inserted', 'success');

                    return response;
                }
            ).catch(this.handleSubmitError);

        }).catch(this.handleSubmitError);
    }

    handleSetDeviceKeys = (values) => {

        let _deviceKeys = values;

        let { storageTag, storageItem } = this.deviceStorage;
        _deviceKeys.devEui = this.deviceService.storage.getItem(storageTag, storageItem).devEui;
        // _deviceKeys.appKey = '00000000000000000000000000000000';

        return this.deviceService.setDeviceKeys(_deviceKeys).then(
            (response) => {
                this.deviceKeyStorage = response;
                this.stepManagerAdvance();
                this.renderAlert('Device Keys Inserted', 'success');
            }
        ).catch(this.handleSubmitError);

    }

    renderGetApplication = () => {
        if (this.state.finished !== 0) {
            return null;
        }
        return (
            <div>
                <FormComponent
                    initialValues={{ limit: '' }}
                    validateFunc={null}
                    submitFunc={this.handleApplicationList}
                    inputs={[
                        { key: 'limit', type: 'text', inputType: 'input', placeholder: 'limit', label: 'Limit' }
                    ]}
                />

            </div>
        );
    };

    renderSetDeviceKeys = () => {

        return (
            <div>
                <FormComponent
                    initialValues={{
                        devEUI: '',
                        nwkKey: '00000000000000000000000000000000',
                        genAppKey: '00000000000000000000000000000000'
                    }}
                    validateFunc={(values) => {
                        const errors = {};
                        let hexRegexp = /^[0-9a-fA-F]+$/;
                        if (!values.nwkKey) { errors.nwkKey = 'Required'; }
                        if (!values.genAppKey) { errors.genAppKey = 'Required'; }
                        if (values.nwkKey.length !== 32) { errors.nwkKey = "wrong length: " + values.nwkKey.length; }
                        if (values.genAppKey.length !== 32) { errors.genAppKey = "wrong length: " + values.genAppKey.length; }
                        if (!hexRegexp.test(values.nwkKey)) { errors.nwkKey = "should be HEX number"; }
                        if (!hexRegexp.test(values.genAppKey)) { errors.genAppKey = "should be HEX number"; }
                        return errors;
                    }
                    }
                    submitFunc={this.handleSetDeviceKeys}

                    inputs={[
                        {
                            key: 'nwkKey', type: 'text', inputType: 'input',
                            placeholder: '32 hexadecimal digit', label: 'Application Key'
                        },
                        {
                            key: 'genAppKey', type: 'text', inputType: 'input',
                            placeholder: '32 hexadecimal digit', label: 'Gen Application Key'
                        }
                    ]}
                />
            </div>
        );
    }

    renderDevice = () => {

        let { thingsboardDevices, applicationList, deviceProfileList } = this.state;

        if (!thingsboardDevices) { return null; }
        if (!applicationList) { return null; }
        if (!deviceProfileList) { return null; }

        return (
            <div>
                <FormComponent
                    initialValues={{
                        devEUI: '',
                        joinEUI: '',
                        thbDevice: '',
                        applicationID: '',
                        deviceProfileID: '',
                    }}
                    validateFunc={(values) => {
                        const errors = {};
                        const devEUI = (values.devEUI || '').trim();
                        const joinEUI = (values.joinEUI || '').trim();
                        const euiRegexp = /^[0-9a-fA-F]{16}$/;

                        if (!devEUI) { errors.devEUI = 'Required'; }
                        else if (!euiRegexp.test(devEUI)) { errors.devEUI = 'Must contain exactly 16 hexadecimal digits'; }

                        if (joinEUI && !euiRegexp.test(joinEUI)) {
                            errors.joinEUI = 'Must contain exactly 16 hexadecimal digits';
                        }
                        return errors;
                    }
                    }
                    submitFunc={this.handleDeviceAdd}


                    inputs={[
                        {
                            key: "thbDevice",
                            type: 'select',
                            inputType: 'select',
                            label: "ThingsBoard Device",
                            options: !!thingsboardDevices ? thingsboardDevices.map(element => {
                                return { value: element.name, label: element.name }
                            }) : '',
                        },
                        {
                            key: "applicationID",
                            type: 'select',
                            inputType: 'select',
                            label: "Application",
                            options: !!applicationList ? applicationList.map(element => {
                                return { value: element.name, label: element.name }
                            }) : '',
                        },
                        {
                            key: "deviceProfileID",
                            type: 'select',
                            inputType: 'select',
                            label: "DeviceProfile",
                            options: !!deviceProfileList ? deviceProfileList.map(element => {
                                return { value: element.name, label: element.name }
                            }) : '',
                        },
                        {
                            key: 'devEUI', type: 'text', inputType: 'input',
                            placeholder: '16 hex digits', label: 'Device EUI'
                        },
                        {
                            key: 'joinEUI', type: 'text', inputType: 'input',
                            placeholder: '0000000000000000', label: 'Join EUI (EUI64, optional)'
                        }
                    ]}
                />
                {/* <div>
                    <h4>Application list</h4>
                    <p>{JSON.stringify(applicationList)}</p>
                    <h4>DeviceProfile List</h4>
                    <p>{JSON.stringify(deviceProfileList)}</p>
                    <h4>Organization List</h4>
                    <p>{JSON.stringify(this.state.organizationList)}</p>
                </div> */}
            </div>
        );
    };

    renderDeviceInfo = () => {
        let { storageTag, storageItem } = this.deviceStorage;
        let { name, devEui, joinEui, applicationId, deviceProfileId } = this.deviceService.storage.getItem(storageTag, storageItem);
        let elements = [
            { key: 'NAME', value: name },
            { key: 'EUI', value: devEui },
            { key: 'Join EUI', value: joinEui },
            { key: 'Application', value: applicationId },
            { key: 'Profile', value: deviceProfileId }
        ];
        return (
            <div>
                <ElementList elements={elements} />
            </div>
        )
    }

    renderDeviceKeysInfo = () => {
        let { storageTag, storageItem } = this.deviceKeyStorage;
        let { nwkKey, genAppKey } = this.deviceService.storage.getItem(storageTag, storageItem);
        let elements = [
            { key: 'Application Key', value: nwkKey },
            { key: 'Gen Application Key', value: genAppKey },
        ];

        return (<div> <ElementList elements={elements} /> </div>);
    }

    render() {
        let { title, nextRoute } = this.props;
        let { showAlert, variantAlert, messageAlert } = this.state.alert;
        let documentation = this.documentation(title);
        let { finished } = this.state;
        return (
            <div className="container-fluid">
                {finished && <Redirect to={nextRoute} />}

                <AlertComponent show={showAlert} variant={variantAlert} message={messageAlert} dismissFunc={() => {
                    this.setState({ alert: { showAlert: false } })
                }} />

                <StepManager ref={this.stepManagerRef}
                    startStepId={0} endStepId={1}
                    onFinished={() => this.setState({ finished: true })}
                    documentation={documentation}
                    stepList={[
                        {
                            stepId: 0, stepName: documentation.steps[0].title, formValue: this.renderDevice, dataValue: this.renderDeviceInfo,
                            documentation: documentation.steps[0]
                        },
                        {
                            stepId: 1, stepName: documentation.steps[1].title, formValue: this.renderSetDeviceKeys, dataValue: this.renderDeviceKeysInfo,
                            documentation: documentation.steps[1]
                        },
                    ]}
                />

            </div>
        )
    }
}

export default ChsUiDevice;
export { ChsUiDevice, documentation }